import { MawaniAllowedFinTypes } from "app/dp-world/services/product-config.service";

export enum STATES {
  NEW = 'NEW',
  VERIFIED = 'VERIFIED',
  PRIVILEGED = 'PRIVILEGED',
  DISABLED = 'DISABLED'
}

export enum OrganizationType {
  'BANK' = 'BANK',
  'DTF' = 'DTF',    // Dp world?
  'ORG' = 'ORG',
}

export interface LoginResponse {
  refreshToken: string;
  timestamp: number;
  token: string;
  userData: User;
  data: {
    userData: User;
    user_data: User;
  }
}

/**
 * describes a user across the project
 */
export interface User {
  latest_terms_version: any;
  documents_uploaded_in_mawani: any;
  mawani_org_reference_id: string;
  accepted_terms_version: any;
  user_organisation_type: string;
  required_logistics_documents: any;
  required_trade_documents: any;

  // after mawani integration
  admin: boolean;
  is_credit_limit_set: boolean;
  is_org_verified: boolean;
  is_verified: boolean;
  organisation_id: number;    // currently missing
  organisation_name: string;
  organisation_type: string;
  role: string;
  user_id: string;
  username: string;

  token: string; // bearer token, we assign this.
  refreshToken: string;
  timestamp: number;

  // from cargo flow
  firstName: string;
  middleName?: string;
  lastName: string;
  phone?: string;
  department?: string;
  jobTitle?: string;
  organization?: string;      // TODO: do we need this and orgCode?
  orgCode?: string;
  user_email_id: string;
  user_contact_number?: string;
  user_contact_number_country_Code?: string;
  country?: string;
  languages?: Array<string>;  // TODO: find enum for all languages
  status?: string;
  locale?: string;            // "en-GB"
  timezone?: string;          // "America/Los_Angeles"
  isAvailable?: boolean;      // Ask Management: whether the user can receive new ask assignments
  colorPreference?: string;   // "LT"
  state?: STATES;             // "VERIFIED"
  userCode?: string;          // 6d6a6b4064656d6f696d706f727465722e636f6d  // the id
  picture?: string;           // url of profile picture
  initials?: string;          // generated and added to object on client side for user list.
  invitedAt?: string;
  moreThanDayOld?: boolean;   // generated and added to object on client side to determine if resend button should show
  isAdmin?: boolean;

  dubai_trade_company_name: string; // added this field bcz home/def commponnet through the error
  password?: string;
  org_bank_details: Array<string>;
  registered_country?: string;
  user_department?: string;
  allowed_services?: MawaniAllowedFinTypes;
  removed_ServicesFI_ByOM?: MawaniAllowedFinTypes;
  user_roles: any;
  authorities: any;
  multipleOrgDetails: Array<OrganisationDetails>;
  tenant_code: string;
  companyStatus: StatusCode;
  company_name?: string;
  tenant_switch_allowed?: boolean;
  client_type_code?: string;
  is_lending_organisation?: boolean;
  isUserAuthorisedSignatory?: boolean;
  metadata?: MetaDataInterface;
  credit_policy_allowed?: boolean;
  annual_turnover?: string;
  mawani_org_reference_id_difc?: string;
  isAppliedToLending?: boolean;
  isClientLinkedToFI?: boolean;
  isClientSubmittedForFi?: boolean;
}

export interface FinanceTypeDetails {
  seller: SellerOrBuyerOrFinanceInst,
  buyer: SellerOrBuyerOrFinanceInst,
  finiancialInstitutions: SellerOrBuyerOrFinanceInst,
  approved_credit_limit: string,
  amount_requested: string,
  amount_approved: string,
  amount_disbursed: string,
  currency_type: string
  requested_currency: string;
  approved_currency: string;
  credit_limit_status: string;
}

export interface SellerOrBuyerOrFinanceInst {
  id: number;
  name: string;
}

export interface UserRegistration {
  username: string;
  password: string;
  confirmPassword: string;
  accountType: string;
  firstName: string;
  lastName: string;
  country: string;
  phoneNumber: string;
  email: string;
}

export interface FinanceTypeDetails {
  seller: SellerOrBuyerOrFinanceInst,
  buyer: SellerOrBuyerOrFinanceInst,
  finiancialInstitutions: SellerOrBuyerOrFinanceInst,
  approved_credit_limit: string,
  amount_requested: string,
  amount_approved: string,
  amount_disbursed: string,
  currency_type: string
}

export interface SellerOrBuyerOrFinanceInst {
  id: number;
  name: string;
  label?: string;
  cfId?: any;
}

export interface OrganisationDetails {
  clientTypeRegistrationDetails: Array<ClientTypeRegistrationDetails>;
  companyOverview: CompanyOverview;
  department: string;
  endDate: string;
  userType: string;
  tenantCode?: string;
  companyName?: string;
  companyReference?: string;
  isLendingOrganisation?: boolean;
}

export interface ClientTypeRegistrationDetails {
  clientTypeCode: string;
  clientTypeName: string;
  serviceProviderRegistrationDetails: Array<ServiceProviderRegistrationDetails>;
}

export interface ServiceProviderRegistrationDetails {
  serviceProviderCode: string;
  serviceProviderName: string;
}

export interface CompanyOverview {
  id: number;
  companyName: string;
  companyEmail: string;
  companyReference: string;
  contactNumber: string;
  contactNumberCountryCode: string;
  countryCode: string;
  createdBy: string;
  createdDate: string;
  addressLine1: string;
  isSuspended: boolean;
  lastModifiedBy: string;
  lastModifiedDate: string;
  ownedBy: string;
  stateName: string;
  statusCode: StatusCode;
}

export interface StatusCode {
  description: string;
  name: string;
}

export interface MetaDataInterface {
  last_finance_type: string;
  last_logged_in_company: string;
  last_logged_in_tenant: string;
  last_product_type: string;
}